<template>
  <div>
    <b-form-checkbox
      v-show="!loading"
      :checked="checked"
      :disabled="loading"
      class="!mb-0"
      @change="$emit('change', $event)"
    />
    <b-spinner
      v-if="loading"
      class="!size-[18px]"
      variant="primary"
    />
  </div>
</template>

<script>
export default {
  name: 'ArticleSelectCheckbox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    /**
     * Programmatically sets the loading state.
     * Called externally by ArticleGroup via a template ref.
     * @param {boolean} value
     */
    setLoading(value) {
      this.loading = value
    },
  },
}
</script>
